import { Observable } from "rxjs";
import {last, concatMap} from "rxjs/operators";

export function lastMap(fnc) {
  return function<T>(source: Observable<T>) {
    return source.pipe(
      last(),
      concatMap(fnc)
    );
  }
}
